import { render, staticRenderFns } from "./carpin.vue?vue&type=template&id=fb82eb98&scoped=true"
import script from "./carpin.vue?vue&type=script&lang=js"
export * from "./carpin.vue?vue&type=script&lang=js"
import style0 from "./carpin.vue?vue&type=style&index=0&id=fb82eb98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb82eb98",
  null
  
)

export default component.exports